import * as React from 'react';
import Backdrop from '@mui/material/Backdrop';
import Box from '@mui/material/Box';
import Modal from '@mui/material/Modal';
import Fade from '@mui/material/Fade';
import useWindowDimensions from '../../hooks/WindowDimensions';



const style = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width:  800,
  height:500,
  bgcolor: 'background.paper',
  boxShadow: 24,
  p: 4,
  outline:"none",
  borderRadius:5,
};
const styleResponsive = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width:"100%",
  height:500,
  bgcolor: 'background.paper',
  boxShadow: 24,
  p: 4,
  outline:"none",
  borderRadius:5
};

export default function TransitionsModal(props) {
  const {open,children} = props;
const {width} = useWindowDimensions();
  return (
      <Modal
        aria-labelledby="transition-modal-title"
        aria-describedby="transition-modal-description"
        open={open}
        // onClose={handleCloseModal}
        closeAfterTransition
        BackdropComponent={Backdrop}
        // onBackdropClick={handleCloseModal}
        BackdropProps={{
          timeout: 500,
        }}
      >
        <Fade in={open}>
          <Box sx={width > 450 ? style : styleResponsive}>
            {children}
          </Box>
        </Fade>
      </Modal>
  );
}
